import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const getAdminPassword = () => localStorage.getItem("varenik_admin_pwd") || "";
export const setAdminPassword = (p) => localStorage.setItem("varenik_admin_pwd", p);
export const clearAdminPassword = () => localStorage.removeItem("varenik_admin_pwd");

const withAuth = () => ({ headers: { "X-Admin-Password": getAdminPassword() } });

export const fetchLinks = async () => {
  const { data } = await api.get("/links");
  return data;
};

export const adminLogin = async (password) => {
  const { data } = await api.post("/admin/login", { password });
  return data;
};

export const createLink = async (payload) => {
  const { data } = await api.post("/links", payload, withAuth());
  return data;
};

export const updateLink = async (id, payload) => {
  const { data } = await api.put(`/links/${id}`, payload, withAuth());
  return data;
};

export const deleteLink = async (id) => {
  const { data } = await api.delete(`/links/${id}`, withAuth());
  return data;
};

export const reorderLinks = async (ordered_ids) => {
  const { data } = await api.post("/links/reorder", { ordered_ids }, withAuth());
  return data;
};

export const trackVisit = async () => {
  try {
    await api.post("/track/visit");
  } catch (e) {
    // silent
  }
};

export const trackClick = async (linkId) => {
  try {
    await api.post(`/track/click/${linkId}`);
  } catch (e) {
    // silent
  }
};

export const fetchStats = async () => {
  const { data } = await api.get("/admin/stats", withAuth());
  return data;
};

export const fetchEternalLinks = async () => {
  const { data } = await api.get("/eternal-links", withAuth());
  return data;
};

export const createEternalLink = async (payload) => {
  const { data } = await api.post("/eternal-links", payload, withAuth());
  return data;
};

export const updateEternalLink = async (id, payload) => {
  const { data } = await api.put(`/eternal-links/${id}`, payload, withAuth());
  return data;
};

export const deleteEternalLink = async (id) => {
  const { data } = await api.delete(`/eternal-links/${id}`, withAuth());
  return data;
};
